import React from "react";
import { ContentFinderItems} from "./contentfinderitems";
import { ContentFinderTexts} from "./contentfindertexts";
import Searcher from "./searcher";
import { FinderState } from "../../types/content.types";

const MAX_TEXT_LEN:number=40;

interface PropsType{
	isContentSetNew:boolean;
	contentFinderClick:(itemCode: string, itemText: string) => void;
	showFinder:boolean;
	contentSetDataImsList:string[];
	finderState:FinderState;
	updateFinderState:(finderState: FinderState) => void;
};

const PLACE_HOLDER:string="Search...";
// const PLACE_HOLDER:string="Type to add images";
const FIND_MSG:string="Find Images";

export const getEmptyFinderState = function():FinderState{
	return {
		searchText:'',
		itemsMatched:[],
		categoriesMatched:[],
		textsMatched:[]
	}
}

export default class ContentFinder extends React.Component<PropsType>{

	private searchInputRef:React.RefObject<HTMLInputElement>;
	private searcher:Searcher;

    constructor(props:PropsType){
        super(props);
		
		this.searchAltered=this.searchAltered.bind(this);
		this.itemClicked=this.itemClicked.bind(this);
		this.textClicked=this.textClicked.bind(this);
		this.categoryClicked=this.categoryClicked.bind(this);
		
		this.searcher=new Searcher();

		this.searchInputRef=React.createRef();
    }

	searchAltered(inputText:string){
		if(this.searchInputRef.current!==null)this.searchInputRef.current.focus({preventScroll:true});
		let cleanText=inputText.toLowerCase();
		cleanText = cleanText.replace(/[^a-z0-9'\- ]/g, "");

		let textMatches=this.searcher.getTextSuggestions(cleanText);
		let itemsMatched=this.searcher.findImages(cleanText);
		let categoriesMatched:string[]=[];

		this.props.updateFinderState({searchText:cleanText, itemsMatched:itemsMatched,  categoriesMatched:categoriesMatched, textsMatched:textMatches})
	}

	itemClicked(itemCode:string,item:string){
		this.props.contentFinderClick(itemCode, item);
		if(this.searchInputRef.current!==null)this.searchInputRef.current.focus({preventScroll:true});
	}

	textClicked(itemText:string){
		this.searchAltered(itemText);//not sure about this
	}

	categoryClicked(category:string){
		//decide what to do here
	}

    render(){
		if(this.props.showFinder===false)return null;
		return(
			<div>
			<hr />
				{this.props.isContentSetNew&&<h3>{FIND_MSG}</h3>}
				<SearchInput
					searchAltered={this.searchAltered}
					searchText={this.props.finderState.searchText}
					searchInputRef={this.searchInputRef}
					/>
				<ContentFinderTexts
					textsMatched={this.props.finderState.textsMatched}
					textClicked={this.textClicked}
					/>
				{/* <MatchedCategories
					categoriesMatched={this.state.categoriesMatched}
					categoryClicked={this.categoryClicked}
					/> */}
				<ContentFinderItems 
					searchText={this.props.finderState.searchText}
					contentSetDataImsList={this.props.contentSetDataImsList}
					itemsMatched={this.props.finderState.itemsMatched} 
					itemClicked={this.itemClicked}
					/>
			</div>
		);
	}
}

const SearchInput=function(props:{searchText:string, searchAltered:(text: string) => void, searchInputRef:React.RefObject<HTMLInputElement>}){
	let clearButVisible=props.searchText.length>6;
	// <p>Enter text here to find images</p>
	return(
		<div>
			<div id="teachers-contentfinder-search">
				<input ref={props.searchInputRef} id="teachers-contentfinder-input" type='text' placeholder={PLACE_HOLDER} value={props.searchText} autoComplete="off" onChange={(e)=>props.searchAltered(e.target.value)} maxLength={MAX_TEXT_LEN}></input>
				{clearButVisible&&<span id="teachers-contentfinder-clear" onClick={()=>props.searchAltered("")}>x</span>}
			</div>
		</div>
	)
};

const MatchedCategories=function(props:{categoriesMatched:string[], categoryClicked:(category: string) => void}){
	if(props.categoriesMatched.length===0)return null;
	let categories:React.ReactElement[]=[];
	for(let i=0;i<props.categoriesMatched.length;i++){
		categories.push(
			<div className="teachers-contentfinder-category" onClick={(e)=>props.categoryClicked(props.categoriesMatched[i])} key={props.categoriesMatched[i]}>
				{props.categoriesMatched[i]}
			</div>
		)
	}
	return(
		<div>
			{categories}
		</div>
	);
};
